import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import CourseLevelAdmin from './CourseLevelAdmin'
import Main from './Main'

import Zoom from './Zoom'

import GroupLevelAdmin from './GroupLevelAdmin'

import CourseStudentExport from './CourseStudentExport'

import BestTeachingAwardReport from './BestTeachingAwardReport'
import ZoomMeetings from './ZoomMeetings'

import CreateUsers from './CreateUsers'

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    CourseLevelAdmin,
    Zoom,
    GroupLevelAdmin,
    CourseStudentExport,
    BestTeachingAwardReport,
    ZoomMeetings,
    CreateUsers,
    Main
  })

export default createRootReducer
